import {Component, inject, Input, OnInit} from '@angular/core';
import {TextInputComponent} from "../../../shared/inputs/text-input/text-input.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ButtonComponent} from "../../../shared/components/button/button.component";
import {type AdminSetupPasswordResponse, SetupPasswordRequest} from "../../../core/api/model";
import {BaseComponent} from "../../../shared/base/base-component";
import {State} from "../../../shared/base/base-state";
import {ApiService} from "../../../core/api/api.service";


@Component({
  selector: 'app-setup-password',
  imports: [
    TextInputComponent,
    ReactiveFormsModule,
    ButtonComponent,
    TextInputComponent,
    ButtonComponent
  ],
  templateUrl: './setup-password.component.html',
  styleUrl: './setup-password.component.scss'
})
export class SetupPasswordComponent extends BaseComponent implements OnInit {

  @Input() token?: string;
  formBuilder = inject(FormBuilder);
  apiService = inject(ApiService);

  setupPasswordForm!: FormGroup;

  setupPasswordState = new State<AdminSetupPasswordResponse>();

  ngOnInit(): void {
    this.setupPasswordForm = this.formBuilder.group({
      password: ["", Validators.required],
      confirmPassword: ["", Validators.required],
    }, {validators: [this.passwordsMatchValidator]});
  }

  passwordsMatchValidator(group: FormGroup) {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : {passwordsMismatch: true};
  }

  onSetPasswordClicked() {
    if (!this.setupPasswordForm.valid) {
      return;
    }
    let formData = this.setupPasswordForm.value;
    let request: SetupPasswordRequest = {
      token: this.token ?? '',
      password: formData.password,
    }
    this.executeRequest<AdminSetupPasswordResponse>({
      state: this.setupPasswordState,
      request: this.apiService.adminCreatePassword(request),
      handleSuccess: true,
      onSuccess: () => {
        this.tokenService.logout();
        this.router.navigate(['/login']);
      }
    });
  }

}
